/* eslint-disable react/jsx-closing-tag-location */
import React, { useState, useEffect, useCallback } from 'react';
import { IProps, STEP, PetInitInfo, styles, question, FormField, PetType, evalObject } from './types';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import ProcessBar from './ProcessBar';
import { SessionKEY, useStickyState } from './petHooks';
import { fetchPetInitInfo } from './aboutApi/petInitApi';
import apiService from 'bff/services/commonService';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptions } from 'bff/models/info/sysoptions';
import PreviewPet from './PreviewPet';
import commonService from 'utils/commonService';
import service from 'bff/services/petProductService';
import InsureProcessInform from 'components/InsureProcess/Pet/InsureProcessInform';
import InsureProcessCalc from 'components/InsureProcess/Pet/InsureProcessCalc';
import InsureProcessInformation from 'components/InsureProcess/Pet/InsureProcessInformation';
import { Activity, Code, Postcode } from 'bff/models/info';
import { InsureTypesEnum } from 'constants/enums/insureTypes.enum';
import { YesNoType } from 'constants/enums/yesNo.enum';
import moment from 'moment-timezone';
import sweetAlertService from 'utils/sweetAlertService';
import { CodeId } from 'constants/enums/codeId.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import InsureProcessPayment from 'components/InsureProcess/Pet/InsureProcessPayment/InsureProcessPayment';
import { IPaymentFormValue, IPaymentState } from 'constants/models/components/insurProcess/insureProcessPayment';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import InsureProcessSuccess from 'components/InsureProcess/Pet/InsureProcessSuccess/InsureProcessSuccess';
import SliderBoundless from 'components/SliderBoundless';
import { OTPInfo } from 'bff/models/login';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { MemberProfile } from 'bff/models/member';
import { SactionType } from 'constants/enums/sactionType.enum';
import { DataLayerArgs } from 'react-gtm-module';
import { helperArgGTM, pushGTM } from 'plugins/gtmService';
import { insProcessPetPlanText } from 'constants/enums/insProcessPetPlanText.enum';

const InsureProcessPet: React.FC<IProps> = (props) => {
  const [activeStep, setActiveStep] = useState<STEP>(null);
  const [formField, setFormField] = useState<FormField>({
    fundSource: new Array<question>(0),
    ask: new Array<question>(0),
    inform: new Array<question>(0)
  });
  const [state, setState] = useState<any>({
    applyNo: '',
    prodId: '',
    yesNoSysOpt: new Array(0),
    insTypeId: '',
    insTypeName: '',
    programId: '',
    tempPayment: {},
    tempCalcForm: {
      REPOLICY_NO: ''
    },
    activities: {
      ACTIVITY: []
    },
    validReq: {
      RULECHECK: {
        APPLY_NO: '',
        INSURED_DATA: {
          ID: '',
          NAME: ''
        }
      }
    },
    validReq2: {
      RULECHECK: {
        INSURED_DATA: {
          ID: '',
          MOBILE: '',
          MAIL: ''
        }
      }
    },
    boPayby: {
      POLICY_FEE: 0,
      INS_TYPE_ID: '',
      APPLY_NO: '',
      BC_TYPE: '',
      PROD_ID: '',
      PAYER_LIST: [],
      END_DATE: '',
      START_DATE: '',
      START_HOUR: '',
      POLICY_DELIVERY: '',
      PROD_NAME: '',
      CO_END_DATE: '',
      CAR_LICENSE: '',
      CO_START_DATE: '',
      VO_START_DATE: '',
      VO_END_DATE: '',
      CAR_SURVEY_STATUS: ''
    },
    addReq: {
      PET_PRODUCT: {}
    },
    occupationIdName: '',
    GENDER: '',
    INSURE_TYPE: InsureTypesEnum.Insure,
    repolicyNo: '',
    startDate: '',
    endDate: '',
    petChip: '',
    petName: '',
    petBDay: '',
    petSteril: YesNoType.No,
    petKind: PetType.dog,
    petVarNo: '',
    petVarName: '',
    petVarType: '',
    // 條款勾選
    isDeclear: '', // 是否受監護宣告
    CONTRACTS: [
      { checked: false },
      { checked: false },
      { checked: false },
      { checked: false }
    ],
    ALL_CONTRACHS_CHECKED: false,
    selectedCalcPlan: {
      PREMIUM: 0,
      planName: ''
    },
    sysTime: 0,
    otpInfo: {},
    getOTPTime: 0,
    evalResult: []
  });
  const calcFromRef: any = React.useRef();
  const informationFormRef: any = React.useRef();

  // const variables from api
  const { value: apiInfo, setValue: setApiInfo } = useStickyState<PetInitInfo>(false, SessionKEY.petInsureProcessApiInfo);
  const { value: sysOption, setValue: setSysOption } = useStickyState<SysOptions>(false, SessionKEY.sysOption);

  // init
  const initApiInfo = React.useCallback(async () => {
    const apiConstInfo = await fetchPetInitInfo(InsType.Pet);
    setApiInfo(apiConstInfo);
  }, [setApiInfo]);

  const getSysOption = React.useCallback(async () => {
    const sysOptionReq = { PCLASS: [SysOptType.YESNO, SysOptType.PODELIVERY] };
    const apiConstInfo = await apiService.fetchSysOpts(sysOptionReq);
    if (apiConstInfo) {
      setSysOption(apiConstInfo);
      // 受監護宣告選項順序
      setState((prev: any) => ({
        ...prev,
        yesNoSysOpt: apiConstInfo[SysOptType.YESNO].sort((first, second) => {
          if (first.PARAM_ORDER && second.PARAM_ORDER) return second.PARAM_ORDER - first.PARAM_ORDER;
          return 0;
        })
      }));
    }
  }, [setSysOption]);

  const fetchFormField = async () => {
    const questions = await service.fetchQuestion();
    const fundSource: Array<question> = [];
    const ask: Array<question> = [];
    const inform: Array<question> = [];

    questions.TRANRS.KYC_LIST.forEach((question: question, i: number) => {
      if (question.KYC_TYPE === '') {
        fundSource.push(question);
      };
      if (question.KYC_TYPE === 'Q') {
        ask.push(question);
      }
      if (question.KYC_TYPE === 'N') {
        inform.push(question);
      }
    });

    setFormField({
      fundSource: [...fundSource],
      ask: [...ask],
      inform: [...inform]
    });
  };

  const fetchOccupation = async () => {
    const res = await service.fetchOccupation();
    setState((prev: any) => ({
      ...prev,
      occupations: res
    }));
  };

  const handleValidProdIdChange = (insTypeId: string, prodId: string, tempData: any) => {
    const selectState = tempData;
    // 未執行到商品選擇頁，判斷選取的商品卡片是否更改 或
    // 執行到商品選擇頁， 未選取方案，判斷選取的商品卡片是否更改
    if (!selectState || Object.keys(selectState).length === 0 || (selectState && !selectState.prodId)) {
      return insTypeId !== tempData.insTypeId || prodId !== tempData.prodId;
    }

    // activePlan activeProdId prodId
    // 執行到商品選擇頁，判斷選取的方案是否和商品卡片不符
    return insTypeId !== tempData.insTypeId || prodId !== selectState.prodId;
  };

  const handlePaymentSubmit = async (formVal: IPaymentFormValue, state: IPaymentState) => {
    const activityInfo = await service.fetchActivities(InsType.Pet);

    handleStep(STEP.success);
    setState((prev: any) => ({
      ...prev,
      // 付款屬於機敏資料 不暫存
      // tempPayment: {
      //   tempPaymentFormValue: { ...formVal },
      //   tempPaymentState: { ...state }
      // },
      activities: { ...activityInfo.activities }
    }));

    storageService.removeItem(storageKeys.InsurceProcessPetState);
    storageService.removeItem(storageKeys.PetActiveProdId);

    pushGTM(getGtmArg('purchase'));
  };

  const handlePaymentGoBack = () => {
    handleStep(STEP.preview);
  };

  // 付款屬於機敏資料 不暫存
  // const handlePaymentUnmount = async (formVal: IPaymentFormValue) => {
  //   const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
  //   const tempData = {
  //     ...originTempData,
  //     tempPaymentFormValue: { ...formVal }
  //   };

  //   commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
  // };

  const initBoPayby = useCallback(async () => {
    if (props.match.params.uuid) {
      storageService.removeItem(storageKeys.InsurceProcessPetState);
      const boPaybyRes = await apiService.boPayby(props.match.params.uuid);

      if (typeof boPaybyRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boPaybyRes}`
        }).then(() => {
          props.history.replace(RouterSettings.Home);
        });
        return;
      }

      const initSetting = await fetchPetInitInfo(InsType.Pet);

      setState((prev: any) => ({
        ...prev,
        insTypeId: boPaybyRes.INS_TYPE_ID,
        prodId: boPaybyRes.PROD_ID,
        boPayby: { ...boPaybyRes },
        UICodes: [...initSetting.UICode],
        step: STEP.payment
      }));
    }
  }, [props.history, props.match.params.uuid]);

  /**
    * @description 成功投保頁，顯示熱門活動 Slider
   */
  const handleCreateSlider = () => {
    let sliderBar;
    if (state.activities && state.activities.ACTIVITY.length > 0) {
      const child = state.activities.ACTIVITY.map((activity: Activity, index: number) => {
        return (
          <SliderBoundless.Item key={index}>
            <a href={activity.ACTIVITY_URL} target="_blank" rel="noopener noreferrer">
              <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
            </a>
          </SliderBoundless.Item>
        );
      });
      sliderBar = (
        <div>
          <div className="insure-process__slider-section">
            <SliderBoundless name="insure-process__slider">
              {child}
            </SliderBoundless>
          </div>
        </div>
      );
    }

    return sliderBar;
  };

  const handleStep = (step: STEP) => {
    const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));

    commonService.storageData(storageKeys.InsurceProcessPetState, {
      ...originTempData,
      step
    });

    setActiveStep(step);
  };

  /**
  * @description 取得 OTP 驗證碼方法
  * @param memberProfile 會員基本資料
  * @param isReSent 是否為重新發送
  */
  const handleFetchOTP = async (isReSent?: boolean, policyAddReq?: any) => {
    const tempFillFormVal = { ...state.validReq2.RULECHECK.INSURED_DATA };
    const memberId = tempFillFormVal.ID;
    const mobile = tempFillFormVal.MOBILE;
    const emailAddr = tempFillFormVal.MAIL;

    const result = await apiService.fetchOTP({ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile, SactionType.Insurce, isReSent, undefined, state?.ALL_CONTRACT_CHECKED_TIME);

    if (result) {
      const temp = {
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime()
      };
      setState((prev: any) => ({
        ...prev,
        ...temp
      }));
      const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
      const tempData = {
        ...originTempData,
        ...temp
      };
      commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
      handleStep(STEP.VerifyOTP);
    }
  };

  /**
   * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
   */
  const handleReSetProfile = () => {
    handleStep(STEP.preview);
    setState((prev: any) => ({
      ...prev,
      step: STEP.preview,
      otpInfo: {},
      getOTPTime: 0
    }));
  };

  /**
   * @description 驗證 OTP 驗證碼方法
   * @param otpVerificationReq OTP 驗證頁 Request Model
  */
  const handleVerifyOTP = async (otpCode: string) => {
    const result = await apiService.verifyOTP(state.otpInfo as OTPInfo, otpCode, SactionType.Insurce, false, undefined, state.ALL_CONTRACT_CHECKED_TIME);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'// 'OTP驗證失敗',
        // html: result
      });

      return;
    }

    if (result && state.addReq) {
      //* 在這邊才 service.addVehicle(policyAddReq)
      const addRes = await service.addPetPolicy(state.addReq);
      if (!addRes) return;

      handleStep(STEP.payment);
    }
  };

  const addToCartGTM = (evalResult: evalObject, values: any) => {
    pushGTM(getGtmArg('add_to_cart', evalResult, values));
  };

  const beginCheckoutGTM = (selectedCalcPlan: any, values: any) => {
    pushGTM(getGtmArg('begin_checkout', [selectedCalcPlan], values));
  };

  const getGtmArg = (event: string, evalResult: any = [state.selectedCalcPlan], petInfo = state): DataLayerArgs => {
    return {
      dataLayer: {
        event: 'td_' + event,
        ga4_event_name: event,
        ecommerce: {
          ...event === 'purchase' ? {
            coupon: state.programId || null,
            transaction_id: state.applyNo,
            affiliation: helperArgGTM.getAffiliation,
            payment_method: helperArgGTM.getPaymentMethodText('1')
          } : {},
          currency: helperArgGTM.getCurrency,
          value: evalResult.reduce((acc: any, cur: any) => (acc + cur.PREMIUM), 0),
          items: evalResult.map((item: any) => ({
            item_id: item.PLAN_ID ?? null,
            item_name: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
            affiliation: helperArgGTM.getAffiliation,
            coupon: petInfo.programId || null,
            currency: helperArgGTM.getCurrency,
            item_brand: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
            item_category: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
            item_category2: helperArgGTM.getRenewOrNewText(petInfo.repolicyNo),
            item_category3: helperArgGTM.getBcTypeText('C'),
            item_category4: petInfo.petKind === '0' ? '狗' : petInfo.petKind === '1' ? '貓' : '',
            item_variant: '',
            price: item.PREMIUM,
            quantity: 1,
            item_list_name: insProcessPetPlanText[item.PLAN_ID as keyof typeof insProcessPetPlanText]
          }))
          // items: [{
          //   item_id: state.prodId ?? null,
          //   item_name: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
          //   affiliation: helperArgGTM.getAffiliation,
          //   coupon: state.programId || null,
          //   currency: helperArgGTM.getCurrency,
          //   item_brand: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
          //   item_category: apiInfo ? apiInfo.inscatRes.INS_TYPE_NAME : '',
          //   item_category2: helperArgGTM.getRenewOrNewText(state.tempCalcForm.REPOLICY_NO),
          //   item_category3: helperArgGTM.getBcTypeText('C'),
          //   item_category4: state.petKind === '0' ? '狗' : state.petKind === '1' ? '貓' : '',
          //   item_variant: '',
          //   price: state.selectedCalcPlan.PREMIUM,
          //   quantity: 1,
          //   item_list_name: state.selectedCalcPlan.planName
          // }]
        }
      }
    };
  };

  useEffect(() => {
    const memberId = storageService.getItem(storageKeys.MemberId);

    /**
    * @description 登入彈窗
    */
    const handleProcessCalcLogin = (formVal?: any, state?: any) => {
      // 尚未登入
      sweetAlertService.modal({
        html: `${commonService.getCodeMsg(apiInfo !== false ? apiInfo.UICode : undefined, CodeId.W081)} <br /> ${commonService.getCodeMsg(apiInfo !== false ? apiInfo.UICode : undefined, CodeId.W007)}`,
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: '取消投保'
      }).then((res) => {
        // 確認
        if (res.value) {
          props.history.push({
            pathname: RouterSettings.Login,
            state: { originUrl: RouterSettings.InsureProcess.Pet }
          });
        }
        // 取消
        if (res.dismiss) {
          setActiveStep(1);
          // 導頁至「寵物險」商品首頁
          props.history.push({
            pathname: RouterSettings.Product.PetIns
          });
        }
      });
    };

    if (!memberId) handleProcessCalcLogin();
  }, [apiInfo, props.history]);

  useEffect(() => {
    const petSession = JSON.parse(window.sessionStorage.getItem(SessionKEY.petInsureProcessApiInfo) as string);
    const sysSession = JSON.parse(window.sessionStorage.getItem(SessionKEY.sysOption) as string);
    console.log('petSession:', petSession);
    console.log('sysSession:', sysSession);
    if (!petSession) { initApiInfo(); } else { }
    if (!sysSession) { getSysOption(); } else { }
    // 受監護宣告選項順序
    if (sysSession) {
      setState((prev: any) => ({
        ...prev,
        yesNoSysOpt: sysSession.YESNO.sort((first: any, second: any) => {
          if (first.PARAM_ORDER && second.PARAM_ORDER) return second.PARAM_ORDER - first.PARAM_ORDER;
          return 0;
        })
      }));
    }
  }, [getSysOption, initApiInfo]);

  useEffect(() => {
    commonService.scrollToTop();
  }, [activeStep]);

  useEffect(() => {
    fetchFormField();
    fetchOccupation();
    initBoPayby();
    // 險種
    let insTypeIdVal: string = InsType.Pet;
    // 商品 Id
    let prodIdVal: string = '';
    // 專案代碼
    let programIdVal: string = '';
    if (storageService.getItem(storageKeys.PetActiveProdId)) {
      const temp = JSON.parse(storageService.getItem(storageKeys.PetActiveProdId)) as InsureProcessTemp;

      prodIdVal = temp.PROD_ID || '';
      insTypeIdVal = temp.INS_TYPE_ID || InsType.Pet;
      programIdVal = temp.PROGRAM_ID || '';
    }

    // #region 判斷有無暫存資料 進行設值

    // 有暫存資料且暫存資料已到期，或選擇不同商品，刪除暫存資料
    if (storageService.getItem(storageKeys.InsurceProcessPetState)) {
      const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));

      const isChangeProdId = handleValidProdIdChange(insTypeIdVal, prodIdVal, tempData);
      if (isChangeProdId || moment().isAfter(tempData.expiredDate)) {
        storageService.removeItem(storageKeys.InsurceProcessPetState);
        setActiveStep(null);
      }
    }

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));

    setActiveStep(STEP.calcBill);

    if (tempData) {
      // console.log('設定暫存資料');
      setState((prev: any) => ({
        ...prev,
        ...tempData.tempCalcForm,
        ...tempData.tempInformationForm,
        insTypeId: tempData.insTypeId,
        applyNo: tempData.applyNo,
        prodId: tempData.prodId,
        programId: tempData.programId ? tempData.programId : programIdVal,
        validReq: tempData.validReq,
        validRes: tempData.validRes,
        validReq2: tempData.validReq2,
        petPic: tempData.petPic,
        addReq: tempData.addReq,
        otpInfo: tempData.otpInfo,
        getOTPTime: tempData.getOTPTime
      }));
      setActiveStep(tempData.step || STEP.calcBill);
      return;
    }

    setState((prev: any) => ({
      ...prev,
      insTypeId: insTypeIdVal,
      prodId: prodIdVal,
      programId: programIdVal
    }));
  }, [initBoPayby]);

  return (
    <div className={`insure-process insure-process--${InsTypeDefinesEN[InsType.Fire]} insure-process--${InsTypeDefinesEN[InsType.Pet]}`}>
      <div className="insure-process__header">
        <ProcessBar activeStep={activeStep} />
      </div>
      <div className="insure-process__content">
        <div className="template-container">
          <div className="template-content">
            {/* step1 我要試算 */}
            {
              activeStep === STEP.calcBill
                ? (
                  <InsureProcessCalc
                    {...{
                      apiInfo,
                      sysOption,
                      activeStep,
                      state,
                      setState,
                      calcFromRef,
                      handleStep,
                      addToCartGTM,
                      beginCheckoutGTM
                    }}
                  />
                )
                : null
            }

            {/* step2 填寫資料 */}
            {
              activeStep === STEP.infoFill
                ? (
                  <InsureProcessInformation
                    {...{
                      informationFormRef,
                      activeStep,
                      state,
                      setState,
                      apiInfo,
                      formField,
                      sysOption,
                      handleStep
                    }}
                  />
                )
                : null
            }

            {/* step3 */}
            {
              activeStep === STEP.infoCheck
                ? (
                  <InsureProcessInform
                    {...{
                      formField,
                      activeStep,
                      state,
                      setState,
                      handleStep
                    }}
                  />
                )
                : null
            }

            {/* step4 資料預覽 */}
            {
              activeStep === STEP.preview
                ? (<div className="insure-process--travel">
                  <div className="insure-process-building-info insure-process-fill" style={activeStep === STEP.preview ? undefined : styles.inline}>
                    <PreviewPet
                      postcodes={apiInfo ? apiInfo.postcodes as Postcode[] : []}
                      {...{
                        handleStep,
                        state,
                        setState,
                        handleFetchOTP
                      }}
                    />
                  </div>
                </div>
                )
                : null
            }

            {/* step5 OTP */}
            {
              activeStep === STEP.VerifyOTP
                ? (<div className="insure-process--travel">
                  <div className="insure-process-building-info insure-process-fill" style={activeStep === STEP.VerifyOTP ? undefined : styles.inline}>
                    <OTPVerificationForm
                      memberProfile={{ MEMBER_ID: state.validReq2.RULECHECK.INSURED_DATA.ID, MOBILE: state.validReq2.RULECHECK.INSURED_DATA.MOBILE, EMAIL_ADDR: state.validReq2.RULECHECK.INSURED_DATA.MAIL } as MemberProfile}
                      memberId={state.validReq2.RULECHECK.INSURED_DATA.ID}
                      otpInfo={state.otpInfo as OTPInfo}
                      getOTPTime={state.getOTPTime as number}
                      UICode={apiInfo !== false ? apiInfo.UICode : [] as Code[]}
                      onUnavailableAuth={handleReSetProfile}
                      onGoBack={handleReSetProfile}
                      onSubmit={handleVerifyOTP}
                      onResentOTP={() => handleFetchOTP(true)}
                    />
                  </div>
                </div>
                )
                : null
            }

            {/* 確認付款 */}
            {
              activeStep === STEP.payment
                ? (<div className="insure-process--travel">
                  <div className="insure-process-building-info insure-process-fill" style={activeStep === STEP.payment ? undefined : styles.inline}>
                    <InsureProcessPayment
                      insTypeId={state.insTypeId}
                      UICodes={apiInfo !== false ? apiInfo.UICode : []}
                      tempState={state}
                      onPaymentSubmit={handlePaymentSubmit}
                      onGoBack={handlePaymentGoBack}
                      // 付款屬於機敏資料 不暫存
                      // onUnmount={handlePaymentUnmount}
                      boPayby={state.boPayby}
                    />
                  </div>
                </div>)
                : null
            }

            {/* 成功投保 */}
            {
              activeStep === STEP.success
                ? (<div className="insure-process--travel">
                  <div className="insure-process-building-info insure-process-fill" style={activeStep === STEP.success ? undefined : styles.inline}>
                    <InsureProcessSuccess
                      insTypeId={state.insTypeId}
                      UICodes={apiInfo !== false ? apiInfo.UICode : []}
                      tempState={state}
                      boPayby={state.boPayby}
                    />
                    {handleCreateSlider()}
                  </div>
                </div>)
                : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsureProcessPet;
